import * as _ from "lodash";
import { Components } from "formiojs";

const TextFieldComponent = Components.components.textfield;

export default class MiproClinicianNameTextField  extends TextFieldComponent  {

    static schema() {
        return TextFieldComponent.schema({
            type: "miproClinicianNameTextField",
            label: "Clinician",
            key: "dbo.mipro.miproClinicianName",
            placeholder: "Enter Clinician Name", 
            disabled: false, 
            input: true,
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Clinician",
            group: "basic",
            icon: "user-md",
            weight: 70,
            schema: MiproClinicianNameTextField.schema(),            
        };
    }
}

Components.addComponent("miproClinicianNameTextField", MiproClinicianNameTextField);